import Kyc, { KycFlowSourceEnum } from '../../../banking/components/kyc/Kyc';
import LegacyKyc from '../../../banking/components/kyc-legacy/Kyc';
import {
    BankingExperience,
    useBankingExperience,
} from '../../../common/providers/BankingExperienceProvider';

const KycPage = () => {
    const { bankingExperience } = useBankingExperience();

    return bankingExperience === BankingExperience.CASH_CARD_ACCT ? (
        <Kyc kycFlowSource={KycFlowSourceEnum.SINGLE_CASH_ACCOUNT_FLOW} />
    ) : (
        <LegacyKyc />
    );
};

export default KycPage;
